import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { PostCard } from "../components/PostCard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const PAGE = 10;

export default function WhatsHappening() {
    const [posts, setPosts] = useState([]);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(true);

    const load = async (skip = 0) => {
        setLoading(true);
        try {
            const r = await axios.get(`${API}/posts`, { params: { skip, limit: PAGE } });
            setPosts(p => skip === 0 ? r.data.posts : [...p, ...r.data.posts]);
            setTotal(r.data.total);
        } catch { /* leave as-is */ }
        finally { setLoading(false); }
    };

    useEffect(() => { load(0); }, []);

    useEffect(() => {
        if (!posts.length || !window.location.hash) return;
        const el = document.getElementById(window.location.hash.slice(1));
        if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 100);
    }, [posts]);

    return (
        <div className="min-h-screen bg-[#F5EDD6]" data-testid="whats-happening-page">
            <section className="bg-[#2D5A27] pt-28 pb-14 px-4 border-b-4 border-[#3D2008]">
                <div className="max-w-3xl mx-auto">
                    <span className="font-marker text-[#C9A84C] text-2xl -rotate-1 inline-block mb-2">News & Updates</span>
                    <h1 className="font-anton text-5xl sm:text-7xl lg:text-8xl text-[#F5EDD6] uppercase leading-none mb-4">What's Happening</h1>
                    <p className="font-manrope text-[#F5EDD6]/80 text-lg max-w-xl">Bingo nights, build updates, thank-yous and photos — straight from the SLSA board.</p>
                </div>
            </section>

            <section className="py-12 px-4">
                <div className="max-w-3xl mx-auto space-y-8">
                    {!loading && posts.length === 0 && (
                        <div className="text-center py-16 border-2 border-dashed border-[#3D2008]/40" data-testid="posts-empty">
                            <p className="font-anton text-2xl text-[#3D2008] uppercase mb-2">Nothing posted yet</p>
                            <p className="font-manrope text-[#5C4A35]">Check back soon — or <Link to="/events" className="text-[#C4522A] underline">see upcoming events</Link>.</p>
                        </div>
                    )}
                    {posts.map((p, i) => <PostCard key={p.id} post={p} index={i} />)}
                    {posts.length < total && (
                        <div className="text-center">
                            <button onClick={() => load(posts.length)} disabled={loading} data-testid="posts-load-more"
                                className="px-8 h-12 bg-[#3D2008] text-[#F5EDD6] font-anton uppercase tracking-wider border-2 border-[#3D2008] hover:bg-[#C4522A] transition-colors disabled:opacity-60">
                                {loading ? "Loading…" : "Load more"}
                            </button>
                        </div>
                    )}
                </div>
            </section>
        </div>
    );
}
